import { browser } from "$app/environment";
import { autoDestroyEffectRoot } from "./auto-destroy-effect-root.svelte.ts";

type Primitive = string | null | symbol | boolean | number | undefined | bigint;

function isPrimitive(val: any): val is Primitive {
  return val !== Object(val) || val === null;
}

function getValueFromStorage(key: string) {
  const value = localStorage.getItem(key);

  if (value === null) return { found: false, value: null };

  try {
    return {
      found: true,
      value: JSON.parse(value),
    };
  } catch (e) {
    console.error(`Error when parsing ${value} from persisted store "${key}"`, e);
    return {
      found: false,
      value: null,
    };
  }
}

export function persisted<T>(key: string, initial: T) {
  const existing = browser ? localStorage.getItem(key) : JSON.stringify(initial);

  const primitive = isPrimitive(initial);
  const parsedValue = existing ? JSON.parse(existing) : initial;

  let state = $state<T extends Primitive ? { current: T } : T>(primitive ? { current: parsedValue } : parsedValue);

  autoDestroyEffectRoot(() => {
    $effect(() => {
      const controller = new AbortController();

      addEventListener(
        "storage",
        (event) => {
          if (event.key === key) {
            const val = getValueFromStorage(key);
            if (val.found) {
              state = primitive ? { current: val.value } : val.value;
            }
          }
        },
        { signal: controller.signal },
      );

      return () => controller.abort();
    });

    $effect(() => {
      // @ts-ignore
      const val = primitive ? state.current : state;
      localStorage.setItem(key, JSON.stringify(val));
    });
  });

  return state;
}
